import { makeAutoObservable, runInAction } from 'mobx';
import api from 'api/api';
import { AxiosStatus } from 'api/axiosConfig';
import auth from 'utils/auth';
import { IApiResponse } from 'utils/models';
import { IAccount, IGetAccountsData } from './accounts.model';

export class AccountsStore {
  accounts: IAccount[] = [];

  activeAccountNumber: string | null = null;

  fetchingStatus = AxiosStatus.DEFAULT;

  constructor() {
    makeAutoObservable(this);
  }

  get ghsAccounts() {
    return this.accounts.filter(({ currency }) => currency === 'GHS');
  }

  fetchAccounts() {
    this.fetchingStatus = AxiosStatus.PENDING;
    this.accounts = [];

    return api
      .get(`customer/accounts?loginId=${auth.data?.loginId || ''}`)
      .then((data: IGetAccountsData) => {
        console.log('data', data);
        runInAction(() => {
          this.fetchingStatus = AxiosStatus.SUCCESS;
          this.accounts = data.accounts;
          const defaultActiveAccount = data.accounts[0];
          this.setActiveAccountNumber(defaultActiveAccount.accountNumber);
        });
      })
      .catch((err: IApiResponse) => {
        runInAction(() => {
          this.fetchingStatus = AxiosStatus.FAILURE;
          console.error(err);
        });
      });
  }

  setActiveAccountNumber(accountNumber: string) {
    this.activeAccountNumber = accountNumber;
  }

  resetAccounts() {
    this.accounts = [];
    this.activeAccountNumber = null;
  }
}

const accountsStore = new AccountsStore();

export default accountsStore;
